import SrDatePicker from "./SrDatePicker";

SrDatePicker.install = function(Vue) {
  Vue.component(SrDatePicker.name, SrDatePicker);
};

export default SrDatePicker;


// WEBPACK FOOTER //
// ./packages/SrDatePicker/index.js